import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'jobs';

export const jobsI18nManifest: SliceI18nManifest = {
  owner: 'modules/jobs',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
